import { produce } from "immer";
import {
  FETCH_BLOGS,
  FETCH_BLOGS_SUCCESS,
  FETCH_BLOGS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_BLOGS,
  ADD_BLOGS_SUCCESS,
  ADD_BLOGS_FAILURE,
  //
  EDIT_BLOGS,
  EDIT_BLOGS_SUCCESS,
  EDIT_BLOGS_FAILURE,
  //
  DELETE_BLOGS,
  DELETE_BLOGS_SUCCESS,
  DELETE_BLOGS_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingBlogs: false,
  Blogs: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentBlogs: {},
  // Delete
  isDeleting: false,
};

const BlogsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_BLOGS:
        draft.isFetchingBlogs = true;
        draft.currentBlogs = {};
        break;
      case FETCH_BLOGS_SUCCESS:
        draft.isFetchingBlogs = false;
        draft.Blogs = action.payload;
        break;
      case FETCH_BLOGS_FAILURE:
        draft.isFetchingBlogs = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentBlogs = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentBlogs = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_BLOGS:
        draft.isSubmitting = true;
        break;
      case ADD_BLOGS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_BLOGS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_BLOGS:
        draft.isSubmitting = true;
        break;
      case EDIT_BLOGS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_BLOGS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_BLOGS:
        draft.isDeleting = true;
        break;
      case DELETE_BLOGS_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_BLOGS_FAILURE:
        draft.isDeleting = false;
        break;

      default:
        return state;
    }
  });

export default BlogsReducer;
